<template>
  <div class="operate-box">
    <div class="operate-box-left">
      <div class="operate-add operate-common" @click="add" v-if="showAdd">
        <el-image :src="addImage" class="operate-image"></el-image>
        <span class="operate-txt">{{ addName }}</span>
      </div>
      <div
        class="operate-export operate-common"
        @click="downloadLoading ? '' : upload()"
        v-if="showUpload"
      >
        <el-image
          :src="exportImage"
          class="operate-image"
          v-if="!downloadLoading"
        ></el-image>
        <i class="el-icon-loading" v-else></i>
        <span class="operate-txt">导出</span>
      </div>
    </div>
    <div class="operate-box-right">
      <el-popover
        v-model="popoverState"
        placement="bottom"
        trigger="hover"
        popper-class="head-switch-bt"
        @show="popoverState = true"
        @hide="popoverState = false"
      >
        <div class="popoverDialog">
          <div class="content">
            <div class="list">
              <el-checkbox-group
                v-model="showTableHead"
                @change="checkboxChange"
              >
                <div v-for="(item, i) in tableHeader">
                  <el-checkbox
                    :key="i + 10"
                    :label="item.label"
                    :disabled="item.prop === 'operation'"
                  />
                </div>
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <div
          class="operate-sift operate-common"
          @click="sift"
          v-if="showSift"
          slot="reference"
        >
          <el-image :src="siftImage" class="operate-image"></el-image>
          <span class="operate-txt">筛选</span>
        </div>
      </el-popover>
    </div>
  </div>
</template>
<script>
export default {
  name: "OperateBox",
  props: {
    tableHeader: {
      type: Array,
      default: () => {
        return [];
      },
    },

    showAdd: {
      type: Boolean,
      default: true,
    },
    addName: {
      type: String,
      default: "添加商户",
    },
    showUpload: {
      type: Boolean,
      default: true,
    },
    showSift: {
      type: Boolean,
      default: true,
    },
    // 下载loading
    downloadLoading: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      showTableHead: [],
      saveTableHeader: [], // 保存的最原始头部数组
      popoverState: false,
      addImage: require("@/assets/img/plus.png"),
      exportImage: require("@/assets/img/icon15.png"),
      siftImage: require("@/assets/img/icon.png"),
    };
  },
  watch: {
    saveTableHeader: function (val) {
      this.showTableHead = val.map((v) => v.label);
    },
  },
  created() {},
  mounted() {
    this.saveTableHeader = this.tableHeader;
  },
  methods: {
    checkboxChange(val) {
      // console.log("val", val);
      this.saveTableHeader.forEach((v) => {
        v.show = false;
        val.forEach((s) => {
          if (v.label === s) {
            v.show = true;
          }
        });
      });
      this.$emit("changeHeader", this.saveTableHeader);
    },
    add() {
      this.$emit("add");
    },
    upload() {
      this.$emit("upload");
    },
    sift() {
      this.$emit("sift");
    },
  },
};
</script>
<style scoped lang="scss">
.operate-box {
  display: flex;
  justify-content: space-between;
  .operate-common {
    border-radius: 0.12rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .operate-txt {
    padding-left: 0.1rem;
  }
  .operate-image {
    width: 0.24rem;
    height: 0.24rem;
  }
  .operate-box-left {
    display: flex;
    align-items: center;

    .operate-add {
      width: 1.31rem;
      height: 0.56rem;
      background-color: #526bec;
      color: #ffffff;
      cursor: pointer;
      margin-right: 0.12rem;
    }
    .operate-export {
      width: 1.09rem;
      height: 0.56rem;
      background-color: #ffffff;
      color: #718096;
      cursor: pointer;
    }
  }
  .operate-box-right {
    .operate-sift {
      width: 0.96rem;
      height: 0.56rem;
      color: #718096;
      background-color: #ffffff;
      cursor: pointer;
    }
  }
  .el-icon-loading {
    font-size: 0.22rem;
  }
}
</style>
